<script setup lang="ts">
import { router } from '@inertiajs/vue3'

import { Button } from '@/components/ui/button'
import { useDialog } from '@/composables/useDialog'
import { reinstateLoanApplicationPath } from '@/routes'

interface Props {
  applicationId: string
  rejectedOn: string
}

const props = defineProps<Props>()

const { confirm } = useDialog()

async function openConfirm() {
  const ok = await confirm({
    title: 'Reinstate application?',
    description: `This will restore the application to ${props.rejectedOn.replace(/_/g, ' ')} status.`,
    confirmLabel: 'Reinstate',
    variant: 'default',
  })
  if (!ok) return
  router.post(reinstateLoanApplicationPath(props.applicationId), {}, { preserveScroll: true })
}
</script>

<template>
  <Button size="sm" variant="outline" class="w-full" @click="openConfirm">
    Reinstate Application
  </Button>
</template>
